const addCopySufix = (name, items = []) => {
    const sufix = ' - COPY';
    const copiesCount = items.filter(item => item.name.includes(name + sufix)).length;
    return name.split(sufix)[0] + `${sufix} ${copiesCount ? copiesCount + 1 : ''}`;
};

export default addCopySufix;
